module.exports = __webpack_public_path__ + "static/media/NewSearchIcon.29f127a5.png";